var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('select-type-language',{attrs:{"data_user_types":_vm.select_type_language.type,"data_languages":_vm.select_type_language.languages}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }